import { VscAzure } from "react-icons/vsc"; 
import { FaPython } from "react-icons/fa";

const CertificationsData = [
  {
    id: 1,
    title: "OCI 2025 Data Science Professional",
    issuer: "Oracle",
    date: "2025",
    image: "/oracle.png", 
    color: "border-gray-200", // Special highlight for your top cert
    link: "https://catalog-education.oracle.com/pls/certview/sharebadge?id=57B1B3436D1EF73FB3261196AFC210F7170099D637910C5E40FB402F8407534C"
  },
  {
    id: 2,
    title: "OCI 2025 Generative AI Professional",
    issuer: "Oracle",
    date: "2025",
    image: "/oracle.png",
    color: "border-gray-200",
    link: "https://catalog-education.oracle.com/pls/certview/sharebadge?id=F4EBDA218DE5DCE72786C316FF6AA2C3D674EBFC195B585A9746DFCDCF985252"
  },
  {
    id: 3,
    title: "Azure AI Fundamentals (AI-900)",
    issuer: "Microsoft",
    date: "March 2026",
    icon: VscAzure,
    iconColor: "text-blue-500",
    color: "border-gray-200",
    link: "https://learn.microsoft.com/en-us/users/ombhaltilak-5619/transcript/dz3k4ujqenl592z?tab=credentials-tab" 
  },
  {
    id: 4,
    title: "The Joy of Computing using Python",
    issuer: "NPTEL (IIT Madras)",
    date: "2023",
    image: "/nptel.png",
    color: "border-gray-200",
    link: "https://archive.nptel.ac.in/content/noc/NOC23/SEM2/Ecertificates/106/noc23-cs108/Course/NPTEL23CS108S3451126520284850.pdf"
  }
];

export default CertificationsData;